export const api = {
  url: "https://dashboard.pestgogo.com/",
};
